import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabPanelComponent } from './tab-panel.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [TabPanelComponent],
  imports: [CommonModule, BrowserAnimationsModule],
  exports: [TabPanelComponent],
})
export class TabPanelModule {}
